import React from "react";
import { IconType } from "react-icons";

interface IconRatingProps {
  value: number;
  onChange: (value: number) => void;
  maxValue?: number;
  label?: string;
  disabled?: boolean;
  Icon: IconType;
  filledClassName: string;
  emptyClassName: string;
}

export function IconRating({
  value,
  onChange,
  maxValue = 5,
  label,
  disabled = false,
  Icon,
  filledClassName,
  emptyClassName,
}: IconRatingProps) {
  const handleClick = (index: number) => {
    if (!disabled) {
      onChange(index + 1);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      {label && (
        <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {label}
        </label>
      )}
      <div className="flex items-center gap-1">
        {Array.from({ length: maxValue }).map((_, index) => {
          const itemValue = index + 1;
          const isFilled = itemValue <= value;

          return (
            <button
              key={index}
              type="button"
              onClick={() => handleClick(index)}
              disabled={disabled}
              className={`transition-all ${
                disabled
                  ? "cursor-not-allowed opacity-50"
                  : "cursor-pointer hover:scale-110"
              }`}
            >
              <Icon
                size={24}
                className={isFilled ? filledClassName : emptyClassName}
              />
            </button>
          );
        })}
        {value > 0 && (
          <span className="ml-2 text-sm text-gray-600 dark:text-gray-400">
            {value}/{maxValue}
          </span>
        )}
      </div>
    </div>
  );
}
